import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var DEFAULT_TIMING_FN = function DEFAULT_TIMING_FN(attempts) {
  return [500, 1000, 5000, 10000][attempts] || 10000;
};

export var Timer = /*#__PURE__*/function () {
  function Timer(callback, timingFn) {
    _classCallCheck(this, Timer);

    this.callback = callback;
    this.timingFn = timingFn || DEFAULT_TIMING_FN;
    this.attempts = 0;
    this.timeout = null;
  }

  _createClass(Timer, [{
    key: "reset",
    value: function reset() {
      this.attempts = 0;
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return this.timeout !== null;
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this = this;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this.attempts = _this.attempts + 1;

        _this.callback();
      }, this.timingFn(this.attempts));
    }
  }]);

  return Timer;
}();